
import React from "react";
import { Route, Redirect } from "react-router-dom";
const checkAuth = () =>{
    const token = localStorage.getItem("staffToken");
    const sessionTime = localStorage.getItem("staffExpireTimeToken");
    if(token){
        try{
            if(Number(sessionTime) > new Date().getTime()){
                return true;
            }
        }
        catch(e){
            return false;
        }
    }
        return false;
    }


const StaffProtectedRoute = ({ component: Component, ...rest}) =>{
    return <Route {...rest} render = {props =>{
        if(checkAuth()){
            return <Component {...props} />
        }
        else{
            return <Redirect to={{pathname: "/Login"}}/>
        }
        
    }}/>
}

export default StaffProtectedRoute;